module.exports = __webpack_public_path__ + "img/map1.3b96394a.png";